import { theme, useFilter, useMap } from 'rwl-ui';
import { OutlineButtonNeutral } from 'rwl-ui/src/theme/Button';
import styled from '@emotion/styled';
import { FilterMatchingJobs, MAX_MATCHING_JOBS } from './FilterMatchingJobs';
import { useGlobal } from '../../hooks';
import { useFetchJobs } from '../../fetchers/JobFetcher/useFetchJobs';
import { useEffect, useState } from 'react';

const EmptyJobListContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: var(--rwl-spacing-sm);
`;

export const EmptyJobList = (): JSX.Element => {
    const { clearAppliedFilters } = useFilter();
    const { clearBounds } = useMap();
    const { accountId, config } = useGlobal();
    const { appliedFilters } = useFilter();

    const emptyResults = {
        title: 'No exact matches',
        description: 'Try changing or removing some of your filters.',
        buttonText: 'Clear filters',
    };
    const emptyArea = {
        title: 'No jobs in this area',
        description: 'Try adjusting your search area.',
        buttonText: 'Show nearest results',
    };
    const [emptyMessage, setEmptyMessage] = useState(emptyResults);

    const { data, isLoading } = useFetchJobs({
        accountId,
        filters: appliedFilters,
        enabled: true,
        bounds: undefined,
        pageSize: MAX_MATCHING_JOBS,
        showcaseOnly: config?.extraData?.showcaseOnly,
    });
    useEffect(() => {
        if (isLoading || !data?.workSites?.length) {
            setEmptyMessage(emptyResults);
        } else {
            setEmptyMessage(emptyArea);
        }
    }, [isLoading, data]);

    return (
        <EmptyJobListContainer>
            <div
                style={{
                    color: theme.text.light.default.toString(),
                    fontWeight: theme.typography.h2.fontWeight,
                    paddingBottom: theme.spacing.sm,
                    lineHeight: theme.typography.h2.lineHeight,
                }}
            >
                {emptyMessage.title}
            </div>
            <div
                style={{
                    color: theme.text.light.default.toString(),
                    paddingBottom: theme.spacing.lg,
                }}
            >
                {emptyMessage.description}
            </div>
            <OutlineButtonNeutral
                onClick={() => {
                    clearAppliedFilters();
                    clearBounds();
                }}
            >
                {emptyMessage.buttonText}
            </OutlineButtonNeutral>
            <FilterMatchingJobs onShowMoreClicked={() => clearBounds()} />
        </EmptyJobListContainer>
    );
};
